var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7,12l4-3.9c.1-.1.2-.2.3-.4,0-.1,0-.3,0-.5s0-.3,0-.5c0-.1-.1-.3-.3-.4-.1-.1-.2-.2-.4-.3-.1,0-.3,0-.5,0s-.3,0-.5,0c-.1,0-.3.1-.4.3l-3.9,4-3.9-4c-.1-.1-.2-.2-.4-.3-.1,0-.3,0-.5,0s-.3,0-.5,0c-.1,0-.3.1-.4.3s-.2.2-.3.4c0,.1,0,.3,0,.5s0,.3,0,.5c0,.1.1.3.3.4l4,3.9-4,3.9c-.1.1-.2.2-.3.4,0,.1,0,.3,0,.5s0,.3,0,.5c0,.1.2.3.3.4.1.1.2.2.4.3.1,0,.3,0,.5,0s.3,0,.5,0,.3-.2.4-.3l3.9-4,3.9,4c.1.1.2.2.4.3.1,0,.3,0,.5,0s.3,0,.5,0c.1,0,.3-.2.4-.3.1-.1.2-.2.3-.4,0-.1,0-.3,0-.5s0-.3,0-.5c0-.1-.2-.3-.3-.4l-4-3.9Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.8c3452421c550a495424410b6c4baaec.svg";
export { ForwardRef as ReactComponent };